
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pregnancyoracle/contraction-counter",
      function () {
        return require("private-next-pages/pregnancyoracle/contraction-counter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pregnancyoracle/contraction-counter"])
      });
    }
  